<template>
	<div class="rightPart">
		<div class="echartBox">
			<div class="title">
				<span class="">
					营收情况
				</span>
			</div>
			<div id="echart2"></div>
		</div>
		<div class="echartBox">
			<div class="title">
				<span class="">
					加盟情况
				</span>
			</div>
			<div id="echart3"></div>
		</div>
		<div class="echartBox">
			<div class="title">
				<span class="">
					营收结构
				</span>
			</div>
			<div id="echart4"></div>
		</div>
	</div>
</template>


<script>
	export default {
		name: 'rightPart',
		data() {
			return {
				colorArr: ['#00deff', "#005aff"],
				objData2: {
					labArr: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
					dataArr: ['0', '4', '27', '2', '10', '3', '1', '1', '3', '2', '0', '3'],
				},
				objData3: {
					labArr: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
					legendArr: ["广告商", "加盟商家"],
					dataArr1: ['0', '4', '27', '23', '10', '3', '1', '1', '3', '2', '0', '3'],
					dataArr2: ['12', '4', '27', '2', '10', '3', '1', '11', '3', '2', '0', '3'],
				},
				objData4: {
					valueData: [{
							name: "商城",
							value: "35"
						},
						{
							name: "充电",
							value: "65"
						},
						{
							name: "广告",
							value: "45"
						}
					],

				}
			}
		},
		mounted() {
			this.getdata()
			// this.init()
		},
		methods: {

			getdata() {
				this.$api.revenueSituation({}).then(res => {
					console.log(res)
					this.objData2.labArr = res.obj.monthList
					this.objData2.dataArr = res.obj.revenueList
					this.drawLine2()

				}).catch(function(error) {
					console.log(error);
				});

				this.$api.joinSituation({}).then(res => {
					console.log(res)
					this.objData3.labArr = res.obj.monthList
					this.objData3.dataArr1 = res.obj.advertiserList
					this.objData3.dataArr2 = res.obj.franchiseList
					this.drawLine3()

				}).catch(function(error) {
					console.log(error);
				});

				this.$api.revenueStructure({}).then(res => {
					console.log(res)
					this.objData4.valueData = []
					res.obj.forEach((item) => {
						var obj = {
							name: item.name,
							value: item.revenueAmount
						}
						this.objData4.valueData.push(obj)
					})
					this.drawLine4()

				}).catch(function(error) {
					console.log(error);
				});

			},

			init() {
				this.$nextTick(() => {
					// 营收情况
					this.drawLine2()
					// 加盟情况
					this.drawLine3()
					// 营收结构
					this.drawLine4()
				})
			},
			getnum(num, n) {
				var s = num.toString();
				let result = ''
				if (s.indexOf(".")) {
					result = s.substring(0, s.indexOf(".") + n);
				} else {
					result = num
				}
				return result
			},
			drawLine2() {
				let that = this
				const myChart = this.$echarts.init(document.getElementById('echart2'))
				myChart.clear()
				myChart.setOption({
					tooltip: {
						trigger: 'axis',
						backgroundColor: 'rgba(255,255,255,0.9)',
						padding: [15],
						borderWidth: 0,
						formatter: function(params) {
							let str = params[0].name + '月<br/>'
							for (let item of params) {
								str +=
									"<div style='text-align: left;'><span style='display:inline-block;width:10px;height:10px;border-radius:10px;background-color:" +
									item.color + ";'></span>" + "\t" + item.seriesName + " : " + item.value +
									'<br/></div>'
							}
							return str

						},
					},
					color: that.colorArr,
					grid: {
						left: '8%',
						right: '6%',
						bottom: '5%',
						top: '15%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: that.objData2.labArr,
						axisLabel: {
							interval: 0,
							textStyle: {
								color: '#c9d9ec',
								fontSize: 14
							},
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: '#00deff'
							}
						},
						axisTick: {
							show: false,
						},
					},
					yAxis: {
						type: 'value',
						name: '      营收（元）',
						nameTextStyle: { //y轴上方单位的颜色
							color: '#c9d9ec',
							fontSize: 16
						},
						axisLabel: {
							textStyle: {
								color: '#c9d9ec',
								fontSize: 16
							},
						},
						splitLine: { //分割线配置
							lineStyle: {
								color: "#4b6a7d",
							}
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: '#00deff'
							}
						},
						axisTick: {
							show: false,
						},
					},
					series: [{
						barWidth: 14,
						data: that.objData2.dataArr,
						type: 'bar',
						name: "营收",
						itemStyle: {
							normal: {
								barBorderRadius: [30, 30, 0, 0],
								shadowColor: '#00deff',
								shadowBlur: 4,
							}
						},
					}]
				})
			},
			transNumberToShort(value, decimal = 2) {
				const k = 10000
				const sizes = ['', '万', '亿', '万亿']
				let i = undefined
				let str = ''
				if (value < k) {
					str = value
				} else {
					i = Math.floor(Math.log(value) / Math.log(k))
					str = ((value / Math.pow(k, i))).toFixed(decimal) + sizes[i]
				}
				return str
			},
			drawLine3() {
				let that = this
				const myChart = this.$echarts.init(document.getElementById('echart3'))
				myChart.clear()
				myChart.setOption({
					tooltip: {
						trigger: 'axis',
						backgroundColor: 'rgba(255,255,255,0.9)',
						padding: [15],
						borderWidth: 0,
						formatter: function(params) {
							let str = params[0].name + '月<br/>'
							for (let item of params) {
								str +=
									"<div style='text-align: left;'><span style='display:inline-block;width:10px;height:10px;border-radius:10px;background-color:" +
									item.color + ";'></span>" + "\t" + item.seriesName + " : " + item.value +
									'<br/></div>'
							}
							return str

						},
					},
					color: that.colorArr,
					grid: {
						left: '8%',
						right: '6%',
						bottom: '5%',
						top: '15%',
						containLabel: true
					},
					legend: {
						icon: 'roundRect',
						// orient: 'horizontal',
						itemGap: 20,
						right: '8%',
						itemHeight: 16,
						itemWidth: 16,
						data: that.objData3.legendArr,
						textStyle: {
							color: "#c9d9ec",
							fontSize: 16
						}
					},
					xAxis: {
						type: 'category',
						data: that.objData3.labArr,
						axisLabel: {
							interval: 0,
							textStyle: {
								color: '#c9d9ec',
								fontSize: 14
							},
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: '#00deff'
							}
						},
						axisTick: {
							show: false,
						},
					},
					yAxis: {
						type: 'value',
						name: '      加盟商（户）',
						nameTextStyle: { //y轴上方单位的颜色
							color: '#c9d9ec',
							fontSize: 16
						},
						axisLabel: {
							textStyle: {
								color: '#c9d9ec',
								fontSize: 16
							},
						},
						splitLine: { //分割线配置
							lineStyle: {
								color: "#4b6a7d",
							}
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: '#00deff'
							}
						},
						axisTick: {
							show: false,
						},
					},
					series: [{
						type: 'bar',
						barWidth: 8,
						itemStyle: {
							barBorderRadius: [15, 15, 0, 0],
						},
						name: that.objData3.legendArr[0],
						data: that.objData3.dataArr1
					}, {
						type: 'bar',
						barWidth: 8,
						itemStyle: {
							barBorderRadius: [15, 15, 0, 0],
						},
						name: that.objData3.legendArr[1],
						data: that.objData3.dataArr2
					}, ]
				})
			},
			drawLine4() {
				let that = this
				let num = 0
				for (let j of that.objData4.valueData) {
					num += Number(j.value)
				}
				const myChart = this.$echarts.init(document.getElementById('echart4'))
				myChart.clear()
				myChart.setOption({
					// tooltip: {
					// 	trigger: "item",
					// 	formatter: "{a} <br/>{b}: {c} ({d}%)",
					// },
					tooltip: {
						trigger: 'item',
						backgroundColor: 'rgba(255,255,255,0.9)',
						padding: [15],
						borderWidth: 0,
						formatter: function(params) {
							console.log(params)
							let str =
								"<div style='text-align: left;'><span style='display:inline-block;width:10px;height:10px;border-radius:10px;background-color:" +
								params.color + ";'></span>" + "\t" + params.name + " : " + params.value +
								"\t" + "<br/>" +
								"<span style='display:inline-block;width:10px;height:10px;border-radius:10px;'></span>" +
								"  占比 : " + that.getnum(((params.value / num) * 100), 3) + "%" +
								'<br/></div>'
							return str

						},
					},
					title: {
						text: "526",
						left: "17%",
						top: "32%",
						text: '{title|' + that.transNumberToShort(num) + '}{value| 元}\n{unit|总 数}',
						textStyle: {
							rich: {
								title: {
									fontSize: 18,
									color: '#c9d9ec',
									padding: [0, 0, 1, 0]
								},
								value: {
									color: "#c9d9ec",
									fontSize: 14
								},
								unit: {
									fontSize: 14,
									color: "#c9d9ec",
									align: "center",
									padding: [5, 0, 0, 0]
								}
							}
						},
					},
					color: ["#ff5400", "#52d669", "#1c7dfa"],
					legend: {
						type: "scroll",
						orient: 'vertical',
						height: '80%',
						left: '53%',
						top: '20%',
						//icon: "circle", //设置为圆，删除则为矩形
						itemWidth: 15,
						itemHeight: 15,
						itemGap: 25,
						data: that.objData4.valueData,
						formatter: function(name) {
							console.log(num)
							for (let k of that.objData4.valueData) {
								if (k.name == name) {
									return '{name|' + name + '}{num|' + that.transNumberToShort(k.value) +
										'元}{value|' + that.getnum(((k.value / num) * 100), 3) +
										'%}'
								}
							}
						},
						textStyle: {
							rich: {
								name: {
									fontSize: 14,
									fontWeight: 400,
									width: 35,
									height: 20,
									padding: [0, 0, 0, 5],
									color: '#c9d9ec',
									fontFamily: 'Source Han Sans CN-Regular',
								},
								num: {
									fontSize: 14,
									fontWeight: 500,
									height: 20,
									width: 85,
									align: 'left',
									color: '#c9d9ec',
									fontFamily: 'Source Han Sans CN-Regular',
								},
								value: {
									fontSize: 14,
									fontWeight: 500,
									height: 20,
									width: 50,
									align: 'left',
									color: '#c9d9ec',
									fontFamily: 'Source Han Sans CN-Regular',
								}
							}
						}
					},
					series: [{
							name: "人员类型",
							type: "pie",
							hoverAnimation: false,
							legendHoverLink: false,
							radius: ["65%", "65.2%"],
							center: ["28%", "40%"], //饼状图位置
							color: that.colorArr,
							label: {
								normal: {
									position: "inner",
								},
							},
							labelLine: {
								normal: {
									show: false,
								},
							},
							tooltip: {
								show: false,
							},
							data: [{
								value: 100,
								name: "",
								itemStyle: {
									normal: {
										borderWidth: 3,
										shadowBlur: 10,
										borderColor: "#05d4da",
										shadowColor: "#05d4da",
									},
								},
							}],
						},
						{
							name: "人员类型",
							type: "pie",
							roseType: "radius",
							radius: ["55%", "40%"],
							center: ["28%", "40%"], //饼状图位置
							color: [
								"#ff5400",
								"#ff5400",
								"#52d669",
								"#1c7dfa",
								"#EBEC2F",
							],
							itemStyle: {
								borderRadius: 1, // 间距的宽度
								borderColor: '#0b354f',
								borderWidth: 5
							},
							labelLine: {
								normal: {
									show: false,
								},
							},
							label: {
								normal: {
									show: false,
								},
							},
							data: this.objData4.valueData
						},
					],
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "rightPart.scss"
</style>